import * as React from 'react';
import { BaSeCheckbox, BaSeButton, BaSeTheme } from '@base/react';
import styled from 'styled-components';

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  min-width: 160px;
`;

const STATUS_OPTIONS = [
  { label: 'Ativo', value: true },
  { label: 'Inativo', value: false },
];

export const StatusColumnFilter = ({
  setFilter,
  setTags,
  closeFilter,
  resetSelection,
  setIsClearFilter,
  setIsListService,
  fetchData,
}) => {
  const [selected, setSelected] = React.useState([]);

  const { azulSebrae36 } = BaSeTheme.colors.institucionais;

  const handleToggle = (value) => {
    setSelected((current) => {
      if (current.includes(value)) {
        return current.filter((v) => v !== value);
      }
      return [value];
    });
  };

  // eslint-disable-next-line
  const handleSelect = () => {
    if (!selected.length) return;

    const isAtivoParam = selected[0];

    const tagLabel = `Status: ${selected[0] ? 'Ativo' : 'Inativo'}`;

    resetSelection();
    setIsClearFilter(false);
    setIsListService(true);

    setFilter((current) => ({
      ...current,
      isAtivo: isAtivoParam,
    }));

    setTags((currentTags) => {
      const withoutStatus = currentTags.filter(
        (tag) => !tag?.label?.startsWith('Status'),
      );

      const newTag = {
        label: tagLabel,
        onClose: () => {
          setTags((tags) =>
            tags.filter((tag) => !tag?.label?.startsWith('Status')),
          );
          setFilter((current) => {
            const { isAtivo, ...rest } = current;
            return rest;
          });
          fetchData({
            sort: { field: 'dataConclusao', type: 'DESC' },
          });
          resetSelection();
        },
      };

      return [...withoutStatus, newTag];
    });

    closeFilter();
  };

  return (
    <FilterWrapper>
      {STATUS_OPTIONS.map(({ label, value }) => (
        <BaSeCheckbox
          key={label}
          label={label}
          checked={selected.includes(value)}
          onChange={() => handleToggle(value)}
        />
      ))}
      <BaSeButton
        value="Selecionar"
        color={azulSebrae36}
        size="medium"
        onClick={handleSelect}
        isDisabled={!selected.length}
      />
    </FilterWrapper>
  );
};
